/** @jsx jsx */
import { Global, jsx, css } from '@emotion/core'
import { injectGlobal } from 'emotion'
import PonyFontLocal from 'assets/fonts/CRC15__W.woff'
import PeFont from 'assets/fonts/HelveticaNeueCyr-Light.woff2'
import ponyTheme from 'theme/pony-theme'

injectGlobal`
  	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	  }
	  
	// @font-face {
	// 	font-family: 'PonyFont';
	// 	font-style: normal;
	// 	font-weight: 400;
	// 	src: local('PonyFont'),
	// 	local('PatrickHandSC-Regular'),
	// 	url(${PeFont}) format('woff2');
	// 	unicode-range: U+0100-024f, U+1-1eff,
	// 	U+20a0-20ab, U+20ad-20cf, U+2c60-2c7f,
	// 	U+A720-A7FF;
	// }

	html {
		 font-family: PonyFont;
	}

	.Toastify__toast--success {
		background: ${ponyTheme.global.colors.statusOk}!important;
	}
	.Toastify__toast--warning {
		background: ${ponyTheme.global.colors.statusWarning}!important;
	}
	.Toastify__toast--error {
		background: ${ponyTheme.global.colors.statusCritical}!important;
	}


`
export default () => {
	
	return (
		<Global
			styles={css`
        body {
          background-color: ${ponyTheme.global.colors.background};
        }
     `}
		/>
	)
}